import { Heading } from "../../elements";
import styles from "./section-divider-block.module.less";

export type TSectionDividerBlockProps = {
  title?: string;
};

export const SectionDividerBlock = ({ title }: TSectionDividerBlockProps) => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.divider}></div>
      <div className={[styles.innerWrapper, "max-width padded-sides"].join(" ")}>
        {title && (
          <Heading semanticType={"h2"} visualType={"h2"}>
            {title}
          </Heading>
        )}
      </div>
    </section>
  );
};

export default SectionDividerBlock;
